export default {
  metaTitle: '批量导入商品',
  pageTitle: '从Excel中批量导入商品',
  description1: '单次最大限制为1万行',
  description2: '请按模版格式输入商品数据',
  description3: '点击此处下载Excel模版文件',
  downloadExcel: '下载Excel模版文件',
  description4: '请将商品数据放置在名为item的模版中',
  description5: '请确认表格中的Category是最子级的分类',
  region: '国别',
  warehouse: '仓库',
  storeCategory: '店内分类',
  shelf: '是否上架',
  saveShelf: '保存并上架',
  saveWarehouse: '保存仓库',
  uploadSuccess: '已成功上传',
  importData: '导入数据',
  wrongFormat: '文件格式不正确',
  file: '文件',
  format_xls_xlsx: '格式不正确，请上传.xls,.xlsx文件。',
  waiting: '请等待后台数据处理完成，您无须停留在此页面！',
  retry: '尚有批量导入任务Processing，请稍候再试！',
  maximum_1000: '单次导入数据最大行数为10000！',
  fillInCorrectly: '请正确填写表格信息',
  selectWarehouseCategory: '请选择仓库和店内分类'
}
